// extracted by mini-css-extract-plugin
export var container = "_8n-0";
export var fallback = "_8n-5";
export var fallbackIcon = "_8n-6";
export var hidden = "_8n-2";
export var image = "_8n-3";
export var loaded = "_8n-4";
export var placeholder = "_8n-1";